import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Select, Space, Spin } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const Autocomplete = ({
  onSearch,
  infiniteScroll,
  loadingNextPage,
  options,
  withExtra,
  titleExtra,
  onClickExtra,
  popupClassName,
  onDropdownVisibleChange,
  filterOption = false,
  ...props
}) => {
  const { t } = useTranslation();
  const focusHandler = useCallback(() => {
    if (typeof onSearch === "function") {
      onSearch();
    }
  }, [onSearch]);

  const renderInfiniteLoader = useCallback(() => {
    if (infiniteScroll && loadingNextPage) {
      return (
        <div
          className={`absolute ${
            withExtra ? "bottom-11" : "bottom-0"
          } left-0 w-full`}
        >
          <div className="ant-select-item ant-select-item-option bg-[#F2F4F8]">
            <Space>
              <Spin size="small" />
              <div className="ant-select-item-option-content">Loading...</div>
            </Space>
          </div>
        </div>
      );
    }
    return null;
  }, [infiniteScroll, loadingNextPage, withExtra]);

  const dropdownRender = useCallback(
    (menu) => {
      return (
        <div className="relative">
          {menu}
          {withExtra && (
            <>
              <Divider className="my-2" />
              <Button
                onClick={onClickExtra}
                type="text"
                icon={<PlusOutlined />}
              >
                {titleExtra || ""}
              </Button>
            </>
          )}
          {renderInfiniteLoader()}
        </div>
      );
    },
    [onClickExtra, renderInfiniteLoader, titleExtra, withExtra]
  );

  return (
    <Select
      onFocus={focusHandler}
      popupRender={dropdownRender}
      notFoundContent={props.loading ? <Spin size="small" /> : t("no_data")}
      showSearch
      options={options}
      onSearch={onSearch}
      filterOption={filterOption}
      classNames={{
        popup: {
          root: popupClassName || "",
        },
      }}
      onOpenChange={onDropdownVisibleChange}
      {...props}
    />
  );
};

export default Autocomplete;
